// extracted by mini-css-extract-plugin
export default {"landscapeWrapper":"LandscapeProjectsAddProjectsImpactTargetTemplate_landscapeWrapper__ztOty"};